import { Row } from 'antd';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { getText } from 'utils/stringUtil';
import {
  UNIFIED_PORTAL_CREDENTIALS_MESSAGE,
  LOG_IN,
} from 'constants/languageConstants';
import { AUTH_VIEW } from 'modules/auth/constants/authConstants';
import { setAuthView } from 'modules/auth/slices/employeeAuthSlice';
import SubmitButton from 'components/buttons/SubmitButton/SubmitButton';
import styles from './erAdmin.module.less';

const ErAdmin = () => {
  const dispatch = useAppDispatch();
  const language = useAppSelector((state) => state.benguide.data?.language);
  return (
    <Row justify="center">
      <div>
        <h1 className={styles.textWrapper}>
          {getText(UNIFIED_PORTAL_CREDENTIALS_MESSAGE, language)}
        </h1>
        <SubmitButton
          type="primary"
          onClick={() => {
            dispatch(setAuthView(AUTH_VIEW.LOGIN.type));
          }}
          htmlType="button"
          className={styles.submitPwdButton}
        >
          {getText(LOG_IN, language)}
        </SubmitButton>
      </div>
    </Row>
  );
};

export default ErAdmin;
